module.exports = __webpack_public_path__ + "media/images/tarifario-color-4baa176e2c0a5f3161ecb3877c7626d5.png";